import React from "react"
import { ChartData } from "chart.js"
import get from "lodash/get"

import { DD_MM_YYYY_FORMAT } from "@framework/constants/global"
import { SearchingTrendPointData } from "@framework/types/analytics"

import { labelsFromPeriod, transformSearchingTrendData } from "./utils"

export type ChartFractionMetaData = {
  name: string
  label: string
  color: string
  yAxisID?: string
}

export interface Props {
  startDate: string
  endDate: string
  data: SearchingTrendPointData[]
  fractions: ChartFractionMetaData[]
}

export const useSearchingTrendChartData = (props: Props) => {
  const { fractions, startDate, endDate, data } = props

  return React.useCallback((): ChartData<"line"> => {
    const labels = labelsFromPeriod([startDate, endDate], DD_MM_YYYY_FORMAT)

    const datasetFractions = transformSearchingTrendData(labels, data)

    return {
      labels,
      datasets: fractions.map((it) => ({
        type: "line",
        label: it.label,
        data: get(datasetFractions, it.name, []),
        borderColor: it.color,
        pointHoverBackgroundColor: it.color,
        borderWidth: 2,
        tension: 0.3,
        yAxisID: it.yAxisID,
      })),
    }
  }, [fractions, data, startDate, endDate])
}

export default useSearchingTrendChartData
